export default __webpack_public_path__ + "static/media/paymentSuccessReverse.dbf97b1d.svg";